import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import TopSurvey from "@/components/sections/TopSurvey";
import StatsBar from "@/components/sections/StatsBar";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Benefits from "@/components/sections/Benefits";
import Process from "@/components/sections/Process";
import References from "@/components/sections/References";
import Testimonials from "@/components/sections/Testimonials";
import Partners from "@/components/sections/Partners";
import CtaBlock from "@/components/sections/CtaBlock";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import CookieConsent from "@/components/sections/CookieConsent";
import MobileCta from "@/components/sections/MobileCta";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.1, smoothWheel: true }}>
      <div className="App">
        <Navbar />
        <main>
          <Hero />
          <TopSurvey />
          <StatsBar />
          <About />
          <Services />
          <Benefits />
          <Process />
          <References />
          <Testimonials />
          <Partners />
          <CtaBlock />
          <Contact />
        </main>
        <Footer />
        <MobileCta />
        <CookieConsent />
        <Toaster position="top-center" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
